$(document).ready(function(){
  var currCountry = Shopify.country;
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Huawei Phone must come first because its UA also contains "Android"
  if (userAgent.includes("iPhone")) {
    $("body").addClass("iphone-cart");
  }

  /* For megamenu */
  /*$(document).on("mouseenter", ".site-navigation .site-nav .parent.megamenu", function(){
    $(this).parents(".site-nav").find(".open_dropdown").removeClass("open_dropdown");
    $(this).find("a:first").addClass("open_dropdown");
    $(this).find(".megamenu").addClass("open_megamenu");
    $(this).parents(".header-wrapper").addClass("apply_bg_color");
  });

  $(document).on("mouseleave", ".site-navigation .site-nav .parent.megamenu", function(){
    console.log('mouseleave')
    $(this).find("a:first").removeClass("open_dropdown");
    $(this).find(".megamenu").removeClass("open_megamenu");
    if(!$("#SearchDrawer").is(":visible")){
      $(this).parents(".header-wrapper").removeClass("apply_bg_color");
    }
  });*/

  /*let hoverTimeout;
  $(document).on("mouseenter", ".parent.megamenu", function() {
      clearTimeout(hoverTimeout);
      $(this).parents(".site-nav").find(".open_dropdown").removeClass("open_dropdown");
      $(this).parents(".site-nav").find(".open_megamenu").removeClass("open_megamenu");
      $(this).find("a:first").addClass("open_dropdown");
      $(this).find(".megamenu").addClass("open_megamenu");

    
  });
  $(document).on("mouseleave", ".parent.megamenu", function() {
      let $this = $(this);
      hoverTimeout = setTimeout(function() {
          $this.find("a:first").removeClass("open_dropdown");
          $this.find(".megamenu").removeClass("open_megamenu");
      }, 200);
  });*/

  $(document).on("click", ".open_mob_menu", function(){
    $(this).parent("li").find("ul").addClass("active");
    $(this).parents("nav").addClass("hideCountry");
  });

  $(document).on("click", "ul.active .closemobileMenu", function(){
    $(this).parent("ul").removeClass("active");
    $(this).parent("ul").slideToggle();
    $(this).parents("nav").hasClass("hideCountry") ? $(this).parents("nav").removeClass("hideCountry") : '';
  });
  
  $('.product-accordian details').attr('open', '');
  $(document).on('click', '.product-accordian summary', function(e){
    e.preventDefault();
    var slideEle = $(this).next('div');
    $(this).parents(".product_descr").addClass("active-tab");
    $(this).toggleClass('active').parents('.product-accordian').find('summary').not(this).removeClass('active');
    slideEle.slideToggle().parents('.product-accordian').find('details > div').not(slideEle).slideUp();
    if($(this).parents(".product-accordian").find(".active").length == 0){
      setTimeout(function(){
        $(this).parents(".product_descr").removeClass("active-tab");
      }, 200);
    }
  });
  
  /*$(document).on('click', '.size-popup-btn', function(){
    $('html').addClass('size-pop-opnd');
  });*/

  /* Open size drawer when click from sticky add to cart */
  /*$(document).on('click', '.fix_addtocart .size-popup-btn', function () {
    $(this).closest('.product-single__meta').find('#product-page--form--custom').find('.sz-ppt-popup-btn, .select-mix-match-size-btn').first().trigger("click");
  });*/
  
  if($(".sct-size-popup").length > 0){
    $(".sct-size-popup").find(".sct-popup-body .size-var-list").find(".size-var-col").each(function(){
      if($(this).find(".size-var-item").length == 0){
        $(this).addClass("hide").parents(".size-var-list").addClass("size-var-long");
      }
    });
  }

  $(document).on('click', '.sct-popup-mask', function(){
    if($('.size-inpt-popup').hasClass('opened')) {
      $('.size-inpt-popup').removeClass('opened');
      $('.sct-inpt-mask').removeClass('showed');
      $('.sct-custom-login').removeClass('select-back');
    } else {
      $('html').removeClass('size-pop-opnd');
      setTimeout(function(){
        $('.sct-custom-login').removeClass('select-back');
        $('#sct-size-options').addClass('selected').siblings('.sct-popup-block').removeClass('selected');
        $('.sct-toggle-list').removeClass('opened');
        $('.sct-scbox-mask').removeClass('showed');
      }, 300);
    }
  });

  $(document).on('click', '.sct-popup-close', function(){
    $('.sct-popup-mask').trigger('click');
  });
  
  var is_data = false;

  $(document).on('click', '.sct-size-btn, .sct-bck-btn', function(){
    var id = $('#'+$(this).attr('data-id'));
    var custId = $(this).parents(".sct-size-popup").data("cust-id");
    
    if($(this).attr('data-id') == "sct-size_guide-mix-match"){
      id.addClass('selected').siblings('.sct-popup-block').removeClass('selected');
      $(".sct-custom-login").removeClass("select-back");
    }
    
    if(custId == '' || this.className.includes("sct-bck-btn") == true){
      id.addClass('selected').siblings('.sct-popup-block').removeClass('selected');
      $(".sct-custom-login").removeClass("select-back");
    }
    
    if(typeof $(this).data("var-price") !== 'undefined'){
      id.find(".price").text($(this).data("var-price"));
    }
    if(typeof $(this).data("class") !== 'undefined' && $(this).data("class") != ''){
     id.find('.sct-rgster-btn').attr("data-id", $(this).data("class"));
    }
    
    if(($(this).data("class") == 'sct-garment_measurement' || $(this).data("class") == 'sct-trousers_measurement' || $(this).data("class") == 'sct-jackets_measurement')){
      //$(".garment_measurements_sec").find(".sct-popup-head .select-size-drawer span").text($(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+$(".garment_measurements_sec").find(".sct-tabs-Grid.selected").attr("id")+"-size-data'] .active").text());
      if(custId == ''){
        //$(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-drawer").trigger("click");
        //$(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-button").trigger("click");
      }
    }
    
    var measurement_type = '';
    if(this.className.includes("sct-bck-btn") == false && custId != ''){
      if($(this).data("class") == 'sct-body_measurement' && $(this).parents(".sct-size-popup").data("type") == 'suits'){
        measurement_type = 'suit_body_measurement';
      }else if($(this).data("class") == 'sct-body_measurement' && $(this).parents(".sct-size-popup").data("type") == 'trousers'){
        measurement_type = 'trousers_body_measurement';
      }else if($(this).data("class") == 'sct-body_measurement' && $(this).parents(".sct-size-popup").data("type") == 'jackets'){
        measurement_type = 'jackets_body_measurement';
      }else if($(this).data("class") == 'sct-garment_measurement' && $(this).parents(".sct-size-popup").data("type") == 'suits'){
        measurement_type = 'suit_measurement';
      }else if($(this).data("class") == 'sct-trousers_measurement' && $(this).parents(".sct-size-popup").data("type") == 'trousers'){
        measurement_type = 'trousers_measurement';
      }else if($(this).data("class") == 'sct-jackets_measurement' && $(this).parents(".sct-size-popup").data("type") == 'jackets'){
        measurement_type = 'jackets_measurement';
      }else if($(this).data("id") == 'sct-size_guide' && $(this).parents(".sct-size-popup").data("type") == 'suits'){
        measurement_type = 'ready_to_wear';
      }
      
      /* Get data from previous latest order */
      if(custId != '' && measurement_type != ''){

        id.addClass('selected').siblings('.sct-popup-block').removeClass('selected');
        $(".sct-custom-login").removeClass("select-back");
        
        get_order_data(custId, measurement_type, function(orderData){
          
          if(orderData.success == true){
            /*id.addClass('selected').siblings('.sct-popup-block').removeClass('selected');
            $(".sct-custom-login").removeClass("select-back");*/
      
            if(jQuery.parseJSON(orderData.data.measurement_data).length > 0){
              is_data = true;
              var measureType = orderData.data.measurement_type;
              var finalData = jQuery.parseJSON(orderData.data.measurement_data);
              //var finalData = jQuery.parseJSON('[{"_measurement_type":"suit_measurement"},{"_Measurement_unit":"cm"},{"_size(jacket)":"42L (US) \/ 102 (EU)"},{"_shoulder(jacket)":"29.5 cm"},{"_chest(jacket)":"28.5 cm"},{"_upper_waist(jacket)":"30 cm"},{"_back_length(jacket)":"32.5 cm"},{"_sleeve(jacket)":"35.5 cm"},{"_posture(jacket)":"standard"},{"_hip(jacket)(advance)":"23 cm"},{"_back_width(jacket)(advance)":"27 cm"},{"_front_length(jacket)(advance)":"40.5 cm"},{"_biceps(jacket)(advance)":"21.5 cm"},{"_sleeve_opening(jacket)(advance)":"18.5 cm"},{"_buttoning_position(jacket)(advance)":"+0.5: Higher extremely"},{"_size(trousers)":"28 (US) \/ 46 (EU)"},{"_waist(trousers)":"11.5 cm"},{"_hip(trousers)":"13.5 cm"},{"_inseam(trousers)":"14 cm"},{"_thigh(trousers)":"7 cm"},{"_calf(trousers)":"7 cm"},{"_leg_opening(trousers)":"12 cm"},{"_flat_seat(trousers)":"-1.0: Reduce slightly"},{"_front_rise(trousers)(advance)":"18.5 cm"},{"_back_rise(trousers)(advance)":"20.5 cm"},{"_seat_width(trousers)(advance)":"Standard"},{"_hip_width(trousers)(advance)":"+0.5: Increase minimally"},{"_crotch(trousers)(advance)":"-0.5: Reduce minimally"}]');

              if(measureType == 'suit_body_measurement' || measureType == 'trousers_body_measurement'){
                for(var i=0; i<finalData.length; i++){
                  var key = Object.keys(finalData[i])[0];
                  var values = Object.values(finalData[i])[0];

                  if(key == '_Measurement_unit'){
                    var measurement = Object.values(finalData[i])[0];
                    var upperBodyMeasureType = $(".body_measurement_sec").find("#upper-body").find(".size-toggle").find("input[type='checkbox']").prop("checked");
                    var lowerBOdyMeasureType = $(".body_measurement_sec").find("#lower-body").find(".size-toggle").find("input[type='checkbox']").prop("checked");

                    if(currCountry == 'US'){
                      if(upperBodyMeasureType == false && measurement == "cm" || upperBodyMeasureType == false && measurement == "inch"){ 
                        $(".body_measurement_sec").find("#upper-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                      }
                      if(lowerBOdyMeasureType == false && measurement == "cm" || lowerBOdyMeasureType == false && measurement == "inch"){ 
                        $(".body_measurement_sec").find("#lower-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                      }
                    }else{
                      if(upperBodyMeasureType == false && measurement == "inch"){
                        $(".body_measurement_sec").find("#upper-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                      }else if(upperBodyMeasureType == false && measurement == "cm"){
                        $(".body_measurement_sec").find("#upper-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", false);
                      }
  
                      if(lowerBOdyMeasureType == false && measurement == "inch"){
                        $(".body_measurement_sec").find("#lower-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                      }else if(lowerBOdyMeasureType == false && measurement == "cm"){
                        $(".body_measurement_sec").find("#lower-body").find(".size-toggle").find("input[type='checkbox']").prop("checked", false);
                      }
                    }
                    
                  }
                  if(key.includes('upper-body') || key.includes('lower-body')){
                    var clas = key.split("(")[0].replace("_", "");
                    var value = values.split(" ")[0];
                    var inputObj = $(".body_measurement_sec").find(".sct-popup-body").find(".size-input").find(".size-input-ele[name='"+clas.trim()+"']");

                    /* Default select INCh for US country */
                    if(currCountry == 'US'){
                      if(measurement == 'cm'){
                        //console.log(clas, value);

                        //inputObj.attr("min", (inputObj.attr("min")/2.54).toFixed(1));
                        //inputObj.attr("max", (inputObj.attr("max")/2.54).toFixed(1));

                        var newValue = parseFloat(value);
                        var new_val = (newValue / 2.54).toFixed(1);
                        inputObj.attr("data-calval", (newValue / 2.54).toFixed(2));
                        inputObj.val(new_val.replace(",", "."));
                      }else{
                        inputObj.val(value);
                        inputObj.attr("data-value", value);
                      }
                    }else{
                      inputObj.val(value);
                      if(measurement == 'inch'){
                        inputObj.attr("data-value", value);
                      }else{
                        inputObj.attr("data-value", (value/2.54).toFixed(2));
                      }
                    }
                    
                  }
                  if(key.includes('fit-preference')){
                    $(".body_measurement_sec").find("#fit-preference").find(".fit_pref").find(".pref-ul-grid li[data-title='"+values+"']").addClass("preference_active");
                  }
                  if(key.includes('_Note')){
                    $(".body_measurement_sec").find("#fit-preference").find(".size-note").find(".size_note_cls").text(values);
                  }
                }
              }

              if(measureType == 'suit_measurement' || measureType == 'trousers_measurement' || measureType == 'jackets_measurement'){
                setTimeout(function(){
                  for(var i=0; i<finalData.length; i++){
					
                    var j_key = Object.keys(finalData[i])[0];
                    var j_values = Object.values(finalData[i])[0];
                    
                    if(j_key == '_Measurement_unit'){
                      var j_measurement = Object.values(finalData[i])[0];
                      var jacketMeasureType = $(".garment_measurements_sec").find("#jacket").find(".size-toggle").find("input[type='checkbox']").prop("checked");
                      var trouserMeasureType = $(".garment_measurements_sec").find("#trousers").find(".size-toggle").find("input[type='checkbox']").prop("checked");

                      if(currCountry == 'US'){
                        if(jacketMeasureType == false && j_measurement == "cm" || jacketMeasureType == false && j_measurement == "inch"){
                          $(".garment_measurements_sec").find("#jacket").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                        }
                        if(trouserMeasureType == false && j_measurement == "cm" || trouserMeasureType == false && j_measurement == "inch"){
                          $(".garment_measurements_sec").find("#trousers").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                        }
                      }else{
                        if(jacketMeasureType == false && j_measurement == "inch"){
                          $(".garment_measurements_sec").find("#jacket").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                        }else if(jacketMeasureType == false && j_measurement == "cm"){
                          $(".garment_measurements_sec").find("#jacket").find(".size-toggle").find("input[type='checkbox']").prop("checked", false);
                        }

                        if(trouserMeasureType == false && j_measurement == "inch"){
                          $(".garment_measurements_sec").find("#trousers").find(".size-toggle").find("input[type='checkbox']").prop("checked", true);
                        }else if(trouserMeasureType == false && j_measurement == "cm"){
                          $(".garment_measurements_sec").find("#trousers").find(".size-toggle").find("input[type='checkbox']").prop("checked", false);
                        }
                      }
                    }

                    if(j_key == '_size(jacket)'){
                      $(".garment_measurements_sec").find(".sct-popup-head").find("#jacket-size-data").find(".size-var-col .size-var-item").removeClass("active");
                      $(".garment_measurements_sec").find(".sct-popup-head").find(".select-size-drawer span").text(j_values);
                      if($(".garment_measurements_sec").find(".sct-popup-head").find("#jacket-size-data").find(".size-var-col").find(".size-var-item[data-val='"+j_values.trim()+"']").length > 0){
                        $(".garment_measurements_sec").find(".sct-popup-head").find("#jacket-size-data").find(".size-var-col").find(".size-var-item[data-val='"+j_values.trim()+"']").addClass("active");
                        $(".garment_measurements_sec").find(".sct-popup-footer").find(".sct-add-cart").find(".garment_measure_cart_btn").removeClass("disabled");
                        $(".garment_measurements_sec").find(".sct-popup-footer").find(".sct-add-cart").find(".btm_tab").find(".sct-toggle-item").removeClass("disabled");
                        $(".garment_measurements_sec").find(".tab_cls").find(".sct-type-tabs .sct-type-tab").removeClass("disabled");
                      }
                    }
                    if(j_key == '_size(trousers)'){
                      $(".garment_measurements_sec").find(".sct-popup-head").find("#trousers-size-data").find(".size-var-col").removeClass("active");
                      if(measureType == 'trousers_measurement' || measureType == 'jackets_measurement'){
                        $(".garment_measurements_sec").find(".sct-popup-head").find(".select-size-drawer span").text(j_values);
                      }
                      if($(".garment_measurements_sec").find(".sct-popup-head").find("#trousers-size-data").find(".size-var-col").find(".size-var-item[data-val='"+j_values.trim()+"']").length > 0){
                        $(".garment_measurements_sec").find(".sct-popup-head").find("#trousers-size-data").find(".size-var-col").find(".size-var-item[data-val='"+j_values.trim()+"']").addClass("active");
                        $(".garment_measurements_sec").find(".sct-popup-footer").find(".sct-add-cart").find(".garment_measure_cart_btn").removeClass("disabled");
                      }
                    }

                    if(j_key.includes('jacket')){
                      var j_clas = j_key.split("(")[0].replace("_", "");
                      
                      if(j_values.includes('+') || j_values.includes('-') || j_values.includes('Standard') || j_values.includes('standard')){
                        $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"'] option[data-val='"+j_values.toLowerCase()+"']").prop("selected", true);
                      }else{
                        var j_value = j_values.split(" ")[0];
                        //console.log(j_clas, j_value, (j_value/2.54).toFixed(2))
                        /* Default select INCh for US country */
                        if(currCountry == 'US'){
                          if(j_measurement == "cm"){
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").val((j_value/2.54).toFixed(2));
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").attr("data-calval", (j_value / 2.54).toFixed(2));
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+j_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(j_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }else{
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").val(j_value);
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").attr("data-value", j_value);
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+j_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(j_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }
                        }else{
                          $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").val(j_value);
                          if(j_measurement == "inch"){
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").attr("data-value", j_value);
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+j_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(j_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }else{
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".size-input-ele[name='"+j_clas.trim()+"']").attr("data-value", (j_value/2.54).toFixed(2));
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").removeClass("hide") : '';
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ? '' :
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").addClass("hide");
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm option[value='"+j_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").val(j_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#jacket").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").val('STANDARD');
                            }
                          }
                        }
                      }
                    }
                    if(j_key.includes('trousers')){
                      var t_clas = j_key.split("(")[0].replace("_", "");
                      var trInput = $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".size-input-ele[name='"+t_clas.trim()+"']");
                      if(j_values.includes('+') || j_values.includes('-') || j_values.includes('Standard') || j_values.includes('standard')){
                        $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".size-input-ele[name='"+t_clas.trim()+"'] option[data-val='"+j_values.toLowerCase()+"']").prop("selected", true);
                      }else{
                        var t_value = j_values.split(" ")[0];

                        //console.log(t_clas, t_value, (t_value/2.54).toFixed(2))
                        /* Default select INCh for US country */
                        if(currCountry == 'US'){
                          if(j_measurement == "cm"){
                            trInput.val((t_value/2.54).toFixed(2));
                            trInput.attr("data-calval", (t_value / 2.54).toFixed(2));
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?  
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+t_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(t_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }else{
                            trInput.val(t_value);
                            trInput.attr("data-value", t_value);
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?  
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+t_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(t_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }
                          
                        }else{
                          trInput.val(t_value);
                          if(j_measurement == "inch"){
                            trInput.attr("data-value", t_value);
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? '' : 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").addClass("hide");
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ?  
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").removeClass("hide") : '';
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch option[value='"+t_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val(t_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").val('STANDARD');
                            }
                          }else{
                            trInput.attr("data-value", (t_value/2.54).toFixed(2));
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").hasClass("hide") ? 
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").removeClass("hide") : '';
                            $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").hasClass("hide") ? '' :  
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_inch").addClass("hide");
                            if($(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm option[value='"+t_value+"']").length > 0){
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").val(t_value);
                            }else{
                              $(".garment_measurements_sec").find(".sct-popup-body").find("#trousers").find(".size-input").find(".outer_box .size-input-ele.dropdown_cm").val('STANDARD');
                            }
                          }
                        }
                      }
                    }
                  }
                  
                }, 200);
              }
            }
          }
          else{
            if(measurement_type == 'suit_measurement' || measurement_type == 'trousers_measurement'){
              //$(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-drawer").trigger("click");
              //$(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-button").trigger("click");
            }
            /*setTimeout(function(){
              id.addClass('selected').siblings('.sct-popup-block').removeClass('selected');
              $(".sct-custom-login").removeClass("select-back");
            }, 300);*/
          }
        });
      }
    }
  });
  
  $(document).on('click', '.sct-custom-login .sct-rgster-btn', function(){
    $(this).parents(".sct-custom-login").addClass("select-back");
  });
  
//   $(".no-Abs .sct-type-tab:nth-child(1)").on("click", function(){
//     $(this).parents(".sct-popup-body").addClass('active-one').removeClass('active-two active-three');
//   });
//   $(".no-Abs .sct-type-tab:nth-child(2)").on("click", function(){
//     $(this).parents(".sct-popup-body").addClass('active-two').removeClass('active-one active-three');
//   });
//   $(".no-Abs .sct-type-tab:nth-child(3)").on("click", function(){
//     $(this).parents(".sct-popup-body").addClass('active-three').removeClass('active-one active-two');
//   });
  
  $(document).on('click', '.sct-type-tab', function(){
    var activeId = $(this).parent(".sct-type-tabs").find(".active").data("id");
    var is_res = true;
    var counts = 0;

    if($(this).parent(".sct-type-tabs").find("a").length == 3){
      if($(this).parent(".sct-type-tabs").find("a.active").data("index") == 1 && $(this).data("index") == 3){
        $(this).parents(".body_measurement_sec").find("#"+$(this).parent(".sct-type-tabs").find("a[data-index='"+2+"']").data("id")).find(".size-unt-inpts .outer_box").find(".input_bx_cls").each(function(){
          var curVal = $(this).val();
          if(curVal == '' || curVal <= 0){
            counts+= 1;
          }
        });

        if(counts > 0){
          $(".body_measure_cart_btn").trigger("click");
          //$('.sct-toggle-item[data-index="2"]').trigger('click');
          return false;
        }
      }
    }

    if($(this).data("id") != activeId){
      checkEmptyVal($(this), activeId, function(res){
        if(res == false){
          is_res = false;
        }
      });
  
      if(is_res == false){
        return false;
      }
    }
    
    var id = $('#'+$(this).attr('data-id'));
    var id_name = $(this).attr('data-id');
    //var price = $(this).attr("data-price");
    $(this).addClass('active').siblings('.sct-type-tab').removeClass('active');
    id.addClass('selected').siblings('.sct-size-varients').removeClass('selected');
    
    $('.sct-toggle-item[data-id="'+$(this).attr('data-id')+'"]').trigger('click');
    
    if($(this).parents(".sct-popup-body").hasClass("tab_cls")){
      $(this).parents(".sct-popup-body").removeClass("lower-body-class upper-body-class fit-preference-class trousers-class jacket-class");
      if(id_name == 'Trousers'){
        $(this).parents(".tab_cls").addClass("trousers-class");
      }else{
        $(this).parents(".tab_cls").addClass(id_name+"-class");
      }
    }
    
    /*if($(this).text() == 'FIT PREFERENCE'){
      $("#"+id_name).find(".pref-grid .pref-ul-grid").each(function(){
        if($(this).html().trim() == ''){
 		 $(this).parent().css("display", "none");
        }
      });
    }*/
    
    $(".script_tg [type='application/json']").removeClass("active_pro");
    $(".script_tg [type='application/json']").each(function(){
      if($(this).hasClass(id_name+"_json")){
       $(this).addClass("active_pro");
      }
    });
    
    $(".selector-wrapper").find(".single-option-selector").removeClass("active_select_box");
    $("."+id_name+"_select_box").find(".single-option-selector").addClass("active_select_box");
    
    
    var len = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").length;
    
    if($(this).parents(".sct-popup-block").hasClass("garment_measurements_sec") == false){
      if(len < 2){
        if(len == 0){
          if($(this).parent(".sct-type-tabs").hasClass("no-Abs")){
            $(this).parents(".sct-popup-block").find(".price").text($(this).attr("data-price"));
          }else{
            $(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney($(this).attr("data-price"), theme.moneyFormat));
          }
        }else{
          var prc = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").attr('data-price');
          $(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney(prc, theme.moneyFormat));
        }
        //$(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney($(this).attr("data-price"), theme.moneyFormat));
      }else{
        var price_new_array = [];
        $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").each(function(){
          price_new_array.push($(this).attr("data-price"));
        });
        $(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney(eval(price_new_array.join('+')), theme.moneyFormat))
      }
    }
    
    if($(this).parents(".sct-popup-block").hasClass("body_measurement_sec")){
      var total = $(this).parents(".no-Abs").find(".sct-type-tab").length;
      if($(this).index() == 2 && total == 3){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else if(total == 2 && $(this).index() < 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
      }else if(total == 2 && $(this).index() == 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else{
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
      }
    }else if($(this).parents(".sct-popup-block").hasClass("garment_measurements_sec")){
      var total_tab = $(this).parents(".no-Abs").find(".sct-type-tab").length;
      if($(this).index() == 1 && total_tab == 2){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        //$(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("disabled");
        //console.log($(this).data("id"), $(this).parents(".garment_measurements_sec").find(".custom-size-drawer").find("#"+$(this).data("id")+"-size-data").find(".size-var-col").find(".active").length);
        if($(this).parents(".garment_measurements_sec").find(".custom-size-drawer").find("#"+$(this).data("id")+"-size-data").find(".size-var-col").find(".active").length == 0){
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("disabled");
        }else{
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("disabled");
        }
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else if($(this).index() == 0 && total_tab == 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        //$(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("disabled");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else{
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
        if($(this).parents(".garment_measurements_sec").find(".custom-size-drawer").find("#"+$(this).data("id")+"-size-data").find(".size-var-col").find(".active").length == 0){
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("disabled");
        }else{
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("disabled");
        }
      }
    }
    
    /* set selected size in select size button */
    if($(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+id_name+"-size-data'] .active").text() != ''){
      $(this).parents(".garment_measurements_sec").find(".sct-popup-head .select-size-drawer span").text($(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+id_name+"-size-data'] .active").text());
    }else{
      $(this).parents(".garment_measurements_sec").find(".sct-popup-head .select-size-drawer span").text("Select Size");
    }
    
    if($(this).parents(".sct-size-popup").data("cust-id") == '' || is_data == false){
      //$(this).parents(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-button").trigger("click");
    }
  });

  $(document).on('click', '.size-var-item', function(){
    if($(this).hasClass("f-actv")){
      $(this).addClass('active').parents(".size-var-list").find('.size-var-item').not(this).removeClass('active');
    }else{
      $(this).toggleClass('active').parents(".size-var-list").find('.size-var-item').not(this).removeClass('active');
      $(this).parents(".sct-popup-block").find(".size_add_to_cart_btn").attr("data-var-id", $(this).attr('data-id'));

      if($(this).parents(".sct-size-varients").find(".size-var-list .active").length >0){
        $(this).parents(".sct-popup-block").find(".size_add_to_cart_btn").removeClass("disabled");
      }else{
        $(this).parents(".sct-popup-block").find(".size_add_to_cart_btn").addClass("disabled");
      }

      var len = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").length;
      if(len < 2){
        if($(this).parents(".sct-popup-block").find(".size-var-list").find(".active").length == 0){
          
          if($(this).parents(".sct-popup-block").find(".sct-type-tabs").hasClass("no-Abs")){
            var prc = $(this).parents(".sct-popup-block").find(".sct-type-tabs .active").attr('data-price');
            $(this).parents(".sct-popup-block").find(".ship-price-txt .price").text(prc);
          }else{
            var prc = $(this).parents(".sct-popup-block").find(".sct-type-tabs .active").attr('data-price');
            $(this).parents(".sct-popup-block").find(".ship-price-txt .price").text(theme.Currency.formatMoney(prc, theme.moneyFormat));
          }
          
        }else{
          var new_Price = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").attr('data-price');
          $(this).parents(".sct-popup-block").find(".ship-price-txt .price").text(theme.Currency.formatMoney(new_Price, theme.moneyFormat));
        }
      }else{
        var price_array = [];
        $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").each(function(){
          price_array.push($(this).attr("data-price"));
        });
        $(this).parents(".sct-popup-block").find(".ship-price-txt .price").text(theme.Currency.formatMoney(eval(price_array.join('+')), theme.moneyFormat))
      }

      if($(this).parents(".sct-size-varients").attr('id') == 'Jacket'){
        //$(this).parents(".sct-popup-block").find(".sct-add-cart").find(".size_add_to_cart_btn").removeClass("disabled");
        if($(this).hasClass("active")){
          //$(this).parents(".sct-popup-block").find(".sct-type-tab[data-id='Trousers']").trigger("click");
        }
      }
    }

    if($(this).parents("#sct-size_guide-mix-match").find(".tab_cls").find(".sct-size-varients").length > 1 && $(this).parents("#sct-size_guide-mix-match").find(".tab_cls").find(".sct-size-varients.selected").index() == 1){
      $(this).parents("#sct-size_guide-mix-match").find(".tab_cls").find(".sct-type-tab").eq(1).trigger("click");
    }
  });
  
  $(document).on('click', '.sct-toggle-label', function(){
    var target = $(this).next('.sct-toggle-list');
    target.toggleClass('opened').parents().find('.sct-toggle-list').not(target).removeClass('opened');
    $('.sct-scbox-mask').toggleClass('showed');
  });

  $(document).on('click', '.sct-toggle-item', function(){
    var text = $(this).text();
    var curr_index = $(this).data("index");
    var active_index = $(this).parent(".sct-toggle-list").find(".sct-toggle-item.active").data("index");
    
    var new_id = $(this).attr('data-id');
    var active_id = $(this).parents(".body_measurement_sec").find(".sct-type-tabs").find("a.active").data("id");
    var id = $(this).parents(".sct-popup-block").find('.sct-type-tab[data-id="'+$(this).attr('data-id')+'"]').attr("data-var-id");
    var is_res_tb = true;
    var count = 0;

    if($(this).parent(".sct-toggle-list").find(".sct-toggle-item").length == 3){
      if($(this).parent(".sct-toggle-list").find(".sct-toggle-item").data("index") == 1 && $(this).data("index") == 3){
        $(this).parents(".body_measurement_sec").find("#"+$(this).parent(".sct-toggle-list").find(".sct-toggle-item[data-index='"+2+"']").data("id")).find(".size-unt-inpts .outer_box").find(".input_bx_cls").each(function(){
          var curVal = $(this).val();
          if(curVal == '' || curVal <= 0){
            count+= 1;
          }
        });
        
        if(count > 0){
          $(".body_measure_cart_btn").trigger("click");
          $('.sct-toggle-list').removeClass('opened');
          $('.sct-scbox-mask').removeClass('showed');
          return false;
        }
      }
    }
    
    if($(this).data("id") != active_id){
      checkEmptyVal($(this), active_id, function(res){
        if(res == false){
          is_res_tb = false;
        }
      });
      
      if(is_res_tb == false){
        $('.sct-toggle-list').removeClass('opened');
        $('.sct-scbox-mask').removeClass('showed');
        return false;
      }
    }

    $(this).addClass('active').siblings('.sct-toggle-item').removeClass('active');
    $(this).parents('.sct-toggle-ele').find('.sct-toggle-label span').text(text);
    $('.sct-type-tab[data-id="'+$(this).attr('data-id')+'"]').addClass('active').siblings('.sct-type-tab').removeClass('active');
    $('#'+$(this).attr('data-id')).addClass('selected').siblings('.sct-size-varients').removeClass('selected');
    $('.sct-toggle-list').removeClass('opened');
    $('.sct-scbox-mask').removeClass('showed');
    
    if($(this).parents(".sct-popup-block").find(".sct-popup-body").hasClass("tab_cls")){
      $(this).parents(".sct-popup-block").find(".sct-popup-body").removeClass("lower-body-class upper-body-class fit-preference-class trousers-class jacket-class");
      //$(this).parents(".sct-popup-block").find(".tab_cls").addClass(new_id+"-class");
      
      if(new_id == 'Trousers'){
        $(this).parents(".sct-popup-block").find(".tab_cls").addClass("trousers-class");
      }else{
        $(this).parents(".sct-popup-block").find(".tab_cls").addClass(new_id+"-class");
      }
      
    }
    
    /*if(text == 'FIT PREFERENCE'){
      $("#"+new_id).find(".pref-grid .pref-ul-grid").each(function(){
        if($(this).html().trim() == ''){
 		 $(this).parent().css("display", "none");
        }
      });
    }*/
    
    $(".script_tg [type='application/json']").removeClass("active_pro");
    $(".script_tg [type='application/json']").each(function(){
      if($(this).hasClass(new_id+"_json")){
       $(this).addClass("active_pro");
      }
    });
    
    $(".selector-wrapper").find(".single-option-selector").removeClass("active_select_box");
    $("."+$(this).attr('data-id')+"_select_box").find(".single-option-selector").addClass("active_select_box");
        
    if($(this).parents(".sct-popup-block").find('.sct-size-varients[id="'+$(this).attr('data-id')+'"]').find(".size-var-item").hasClass("active") == false){
     $(".size_add_to_cart_btn").addClass("disabled");
    }else{
     $(".size_add_to_cart_btn").removeClass("disabled");
    }
    
    var len = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").length;
    
    if($(this).parents(".sct-popup-block").hasClass("garment_measurements_sec") == false){
      if(len < 2){
        if(len == 0){
          if($(this).parent(".sct-toggle-list").hasClass("btm_tab")){
            $(this).parents(".sct-popup-block").find(".price").text($(this).attr("data-price"));
          }else{
            $(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney($(this).attr("data-price"), theme.moneyFormat));
          }
        }else{
          var new_Price = $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").attr('data-price');
          $(this).parents(".sct-popup-block").find(".ship-price-txt .price").text(theme.Currency.formatMoney(new_Price, theme.moneyFormat));
        }
      }else{
        var price_new_array = [];
        $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").each(function(){
          price_new_array.push($(this).attr("data-price"));
        });
        $(this).parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney(eval(price_new_array.join('+')), theme.moneyFormat));
      }
    }
    
    if($(this).parents(".sct-popup-block").hasClass("body_measurement_sec")){
      var total = $(this).parents(".sct-popup-block").find(".no-Abs").find(".sct-type-tab").length;
      if($(this).index() == 2 && total == 3){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else if(total == 2 && $(this).index() < 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
      }else if(total == 2 && $(this).index() == 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else{
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
      }
    }else if($(this).parents(".sct-popup-block").hasClass("garment_measurements_sec")){
      var total_tab = $(this).parents(".sct-popup-block").find(".no-Abs").find(".sct-type-tab").length;
      if($(this).index() == 1 && total_tab == 2){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
        if($(this).parents(".garment_measurements_sec").find(".custom-size-drawer").find("#"+$(this).data("id")+"-size-data").find(".size-var-col").find(".active").length == 0){
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("disabled");
        }else{
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("disabled");
        }
      }else if($(this).index() == 0 && total_tab == 1){
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("ADD TO CART");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("next_btn");
      }else{
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").val("NEXT");
        $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("next_btn");
        if($(this).parents(".garment_measurements_sec").find(".custom-size-drawer").find("#"+$(this).data("id")+"-size-data").find(".size-var-col").find(".active").length == 0){
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").addClass("disabled");
        }else{
          $(this).parents(".sct-popup-block").find(".sct-add-cart .btn-cst").removeClass("disabled");
        }
      }
    }
    
    $(this).parents(".sct-popup-block").find(".size_add_to_cart_btn").attr("data-var-id", id);
    if($(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+new_id+"-size-data'] .active").text() != ''){
      $(this).parents(".garment_measurements_sec").find(".sct-popup-head .select-size-drawer span").text($(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+new_id+"-size-data'] .active").text());
    }else{
      $(this).parents(".garment_measurements_sec").find(".sct-popup-head .select-size-drawer span").text("Select Size");
    }
    $(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".get-url-cls").addClass("hide");
    $(this).parents(".garment_measurements_sec").find(".sct-popup-head").find(".size-inpt-body[id='"+new_id+"-size-data']").removeClass("hide");
    if($(this).parents(".sct-size-popup").data("cust-id") == '' || is_data == false){
      //$(this).parents(".garment_measurements_sec").find(".sct-popup-head .custom-size-drawer").find(".select-size-button").trigger("click");
    }
    
  });

  $(document).on('click', '.sct-scbox-mask', function(){
    $('.sct-toggle-list').removeClass('opened');
    $('.sct-scbox-mask').removeClass('showed');
  });

  $(document).on('click', '.size-inpt-ic', function(){
    if($(this).next('.size-inpt-popup').length > 0){
      $(this).next('.size-inpt-popup').addClass('opened');
      $(this).parents('.sct-popup-block').find('.sct-inpt-mask').addClass('showed');
      var text_val = $(this).children("span").text();
      $(this).parents(".size-input").find(".size-ititle").text(text_val);

      let current_val = '';
      var currSelVal = 'STANDARD';
      if($(this).closest("div").find(".outer_box .size-input-ele").hasClass("cls-dropdwn")){
        currSelVal = $(this).closest("div").find(".outer_box .size-input-ele.cls-dropdwn:visible").val();
        $(this).parents(".size-input").find(".size-inpt-footer").find("select option[value='"+currSelVal+"']").prop("selected", true);
      }else{
        current_val = $(this).closest("div").find(".outer_box .size-input-ele").val();
        if(current_val != ''){
          var min = $(this).parents(".size-input").find(".outer_box .size-input-ele").attr("min");
          var max = $(this).parents(".size-input").find(".outer_box .size-input-ele").attr("max");
          $(this).parents(".size-input").find(".size-inpt-footer").find(".size-input-ele").val(current_val);
          $(this).parents(".size-input").find(".size-inpt-footer").find(".size-input-ele").attr("min", min).attr("max", max);
        }
      }
      
      /*var current_val = $(this).parents(".size-input").find(".outer_box .size-input-ele").val();
      var min = $(this).parents(".size-input").find(".outer_box .size-input-ele").attr("min");
      var max = $(this).parents(".size-input").find(".outer_box .size-input-ele").attr("max");
      $(this).parents(".size-input").find(".size-inpt-footer").find(".size-input-ele").val(current_val);
      $(this).parents(".size-input").find(".size-inpt-footer").find(".size-input-ele").attr("min", min).attr("max", max);*/
    }
  });
  
  $(document).on('click', '.sct-inpt-mask', function(){
    $(this).parents('.sct-popup-block').find('.size-inpt-popup').removeClass('opened');
    $(this).parents('.sct-popup-block').find('.sct-inpt-mask').removeClass('showed');
  });

  /*$(document).on('click', '.size-note p', function(){
    $(this).next('.size-txtarea').slideToggle();
  });*/

  $(document).on('click', '.size-guide-link', function(){
    $('.popup-modal[href="#test-modal"]').trigger('click');
  });

  $(document).on('click', '.find-size-link', function(){
    $('.popup-modal-ts').trigger('click');
  });
  
  
  /* Add to cart product with selected size from size guide */
  $(".size_add_to_cart_btn").on("click", function(e){
    var obj = $(this);
    var id = $(this).attr("data-var-id");
    var id_array = [];
    var property = [];
    
    /*console.log(id);
    if($(this).hasClass("next_btn")){
      $(this).parents(".sct-popup-block").find(".sct-type-tabs a").each(function(index, val){
        if($(this).hasClass("active") && $(this).index() < 2){
          $(this).next("a").trigger("click");
          return false;
        }else{
          obj.removeClass("next_btn");
          obj.val("ADD TO CART");
        }
      });
     return false;
    }*/
    
    
    $(this).parents(".sct-popup-block").find(".size-var-list").find(".active").each(function(){
      id_array.push($(this).attr("data-id"));
      var size = $(this).text();
      var type;
      if($(this).parents(".sct-popup-block").find(".sct-type-tabs").length > 0){
        type = $(this).parents(".sct-size-varients").attr("id");
        if(type == "Full Suit") { size += " - Full Suit"; }
      }else{
        size += " - Full Suit";
        type = "Full Suit";
      }
      
      
      property.push({
       "_Type":type,
        "_Size":size
      });
    });
    

    //$(".loadingBox").show();
    $(this).parent(".ld-hydrated-box").addClass("line-loading");
    
    if(id_array.length > 0){
      for(var i=0; i<id_array.length; i++){
        var prop = { 
          "_Type":property[i]['_Type'],
          "_Size":property[i]['_Size']
        }
        
        if(property[i]['_Type'] == 'Full Suit'){
          prop._measurement_type = 'ready_to_wear';
        }
        
        add_to_cart_product(id_array[i], prop, obj);
      }
    }
    if($(this).parents(".sct-popup-block").find(".sct-size-varients").hasClass("selected")){
     $(this).parents(".sct-popup-block").find(".sct-size-varients").find(".size-var-list").find(".active").removeClass("active");
    }
    $(this).addClass("disabled");
  });
  
  /* Add to cart product with body measurements */
  var error_msg = "Please enter data into this input";
  var prop1 = [];
  var suit_data = [];
  
  $(document).on("click", ".body_measure_cart_btn", function(e){
    e.preventDefault();
    var obj = $(this);
    var data_id = $(this).parents(".body_measurement_sec").find(".sct-type-tabs").find("a.active").data("id");
    var is_res2 = true;
    
    //if(typeof data_id !== 'undefined' || data_id != ''){
      checkEmptyVal($(this), data_id, function(res){
        if(res == false){
          is_res2 = false;
        }
      });

      
    //}
    if(is_res2 == false){
      return false;
    }
    
    var id = $(this).attr("data-var-id");
    var parents = $(this).parents(".body_measurement_sec").find(".sct-tabs-Grid.sct-size-varients.selected");
    parents.find(".outer_box").removeClass("err_cls").find(".size-input-ele").removeClass("err_highlight");
    parents.find(".error_msg").text('');
    var note = parents.find(".size_note_cls").val();
    var length = $(this).parents(".body_measurement_sec").find(".sct-tabs-Grid.sct-size-varients.selected .size-unt-inpts").not($(".adv_opt")).find(".outer_box").length;
    
    if($(this).hasClass("next_btn")){
      $(this).parents(".sct-popup-block").find(".sct-type-tabs a").each(function(index, val){
        if($(this).hasClass("active") && $(this).index() < 2){
          $(this).next("a").trigger("click");
          //obj.removeClass("disabled");
          return false;
        }else{
          obj.removeClass("next_btn");
          obj.val("ADD TO CART");
        }
      });
     return false;
    }
    
    if($(this).parents(".sct-size-popup").data("type") == 'suits'){
      prop1["_measurement_type"] = "suit_body_measurement";
    }else if($(this).parents(".sct-size-popup").data("type") == 'trousers'){
      prop1["_measurement_type"] = "trousers_body_measurement";
    }else if($(this).parents(".sct-size-popup").data("type") == 'jackets'){
      prop1["_measurement_type"] = "jackets_body_measurement";
    }
    
    $(this).parents(".body_measurement_sec").find(".sct-tabs-Grid").each(function(){
      var measure = '';
      if($(this).find("input[type='checkbox']").length > 0){
        if($(this).find("input[type='checkbox']").is(":checked") == true){
          measure = "inch";
        }else{
          measure = "cm";
        }
      }
      
      var curr_type = $(this).attr("id");
      if(measure != ''){
        prop1["_Measurement_unit"] = measure;
      }
      
      $(this).find(".input_bx_cls").each(function(){

      /*console.log('val', $(this).val());
        if($(this).val() == ''){
          $(this).parents(".body_measurement_sec").find(".sct-type-tabs").find("[data-id='"+$(this).parents(".sct-tabs-Grid").attr("id")+"']").trigger("click");
          console.log($(this).parents(".sct-tabs-Grid").attr("id"));
          return false;
        }*/
        
        var text = "_"+$(this).attr("name");
        var value = $(this).val();
        
        if(text != ''){
          prop1[text+"("+curr_type+")"] = value+" "+measure;
        }
      });
      
      if($(this).find(".adv_opt").length > 0){
        $(this).find(".adv_opt").find(".size-input .outer_box .size-input-ele").each(function(){
          if($(this).val() != ''){
            var ad_text = "_"+$(this).attr("name");
            var ad_value = $(this).val();
            if($(this).hasClass("cls-dropdwn")){
              prop1[ad_text+"("+curr_type+")(advance)"] = ad_value;
            }else{
              prop1[ad_text+"("+curr_type+")(advance)"] = ad_value+" "+measure;
            }
          } 
        });
      }
      
    });

    if($(this).parents(".body_measurement_sec").find("#fit-preference").length > 0){
      $(this).parents(".body_measurement_sec").find("#fit-preference .fit_pref").each(function(index){
        var heading = $(this).find(".pref-grid:first").find("h3").eq(0).text();
        $(this).find(".pref-grid li.preference_active").each(function(){
          var key = $(this).parents(".pref-grid").find("h2").eq(0).text();
          var new_key = key.charAt(0).toUpperCase()+key.slice(1).toLowerCase();
          prop1["_"+new_key+"(fit-preference)"] = $(this).data("title");
        });
      });
    }
    
    if(note != ''){
     prop1["_Notes"] = note;
    }
    
    //console.log(prop1);
    add_to_cart_product(id, prop1, obj);
    prop1 = [];
  });
  
  /* Add to cart product with garment measurements */
  $(document).on("click", ".garment_measure_cart_btn", function(){
    const obj = $(this);
    var id = $(this).attr("data-var-id");
    var parents = $(this).parents(".garment_measurements_sec");
    var is_res_gr = false;
    parents.find(".outer_box").removeClass("err_cls").find(".size-input-ele").removeClass("err_highlight");
    
    if($(this).hasClass("next_btn")){
      $(this).parents(".sct-popup-block").find(".sct-type-tabs a").each(function(index, val){
        if($(this).hasClass("active") && $(this).index() < 1){
          $(this).next("a").trigger("click");
          return false;
        }else{
          obj.removeClass("next_btn");
          obj.val("ADD TO CART");
        }
      });
      return false;
    }

    /*checkEmptyVal($(this),$(this).parents(".garment_measurements_sec").find(".tab_cls .sct-type-tabs .active").data("id"), function(res){
      console.log("resp", res)
        if(res == false){
          is_res_gr = false;
        }
      });
  
      if(is_res_gr == false){
        return false;
      }else{
        return true;
      }*/
    /*var new_id = $(this).parents(".garment_measurements_sec").find(".tab_cls .sct-type-tabs .active").data("id");
    if(typeof $(this).parents(".garment_measurements_sec").find("#"+new_id+"-size-data").find(".size-var-col").find(".size-var-item.active").data("val") === 'undefined'){
      return false;
    }else{
      return true;
    }*/
    
    if($(this).parents(".sct-size-popup").data("type") == 'suits'){
      suit_data["_measurement_type"] = "suit_measurement";
    }else if($(this).parents(".sct-size-popup").data("type") == 'trousers'){
      suit_data["_measurement_type"] = "trousers_measurement";
    }else if($(this).parents(".sct-size-popup").data("type") == 'jackets'){
      suit_data["_measurement_type"] = "jackets_measurement";
    }
    
    $(this).parents(".garment_measurements_sec").find(".sct-tabs-Grid").each(function(index){
      var measure = '';
      if($(this).find("input[type='checkbox']").is(":checked") == true){
        measure = "inch";
      }else{
        measure = "cm";
      }
      
      suit_data["_Measurement_unit"] = measure;
      var cur_type = $(this).attr("id");
      var cur_size = $("#"+cur_type+"-size-data").find(".size-var-col").find(".size-var-item.active").data("val");

      /*if(typeof cur_size === 'undefined'){
        console.log("Please select size");
        return false;
      }*/
      
      suit_data["_size("+cur_type+")"] = cur_size.trim();
      
      $(this).find(".input_bx_cls").each(function(){
        var label = $(this).parents(".size-input").find(".size-inpt-ic span").text();
        var text = "_"+$(this).attr("name");
        var value = $(this).val();
        
        if(label != ''){
          if($(this).hasClass('cls-dropdwn') == true){
            suit_data[text+"("+cur_type+")"] = value;
          }else{
            suit_data[text+"("+cur_type+")"] = value+" "+measure;
          }
        }
      });
      
      if($(this).find(".adv_opt").length > 0){
        $(this).find(".adv_opt").find(".size-input .outer_box .size-input-ele").each(function(){
          if($(this).val() != ''){
            var ad_text = "_"+$(this).attr("name");
            var ad_value = $(this).val();
            if($(this).hasClass('cls-dropdwn') == true){
              if(!$(this).hasClass("hide")){
                suit_data[ad_text+"("+cur_type+")(advance)"] = ad_value;
              }
            }else{
              suit_data[ad_text+"("+cur_type+")(advance)"] = ad_value+" "+measure;
            }
          } 
        });
      }
      
    });
    
    //console.log(suit_data);
    add_to_cart_product(id, suit_data, obj);
    suit_data = [];
  });
  
  document.querySelectorAll('.size-input-ele').forEach(e=>
    e.addEventListener('change', () =>{
      const el = e.target || e
      if(el.type == "number" && el.max && el.min ){
        let value = parseFloat(el.value)
        el.value = value // for 000 like input cleanup to 0
        let max = parseFloat(el.max)
        let min = parseFloat(el.min)
        if ( value > max ) el.value = el.max
        if ( value < min ) el.value = el.min
      }
    })
  );
  
  /* Convert from cm to inch and vise versa */
  $(document).on("change", "input[type='checkbox'][name='size-unit_lower'], input[type='checkbox'][name='size-unit_upper'], input[type='checkbox'][name='size-unit-trousers'], input[type='checkbox'][name='size-unit-jacket'], input[type='checkbox'][name='size-unit-suit-mesure']", function(){
    if($(this).prop("checked") == true){
      cm_to_inch($(this));
    }else{
      inch_to_cm($(this));
    }
  });

  $(document).on("change", "input[type='checkbox'][name='jacket_measure'], input[type='checkbox'][name='jacket_gr_measure'], input[type='checkbox'][name='trouser_measure'], input[type='checkbox'][name='trouser_gr_measure'], input[type='checkbox'][name='waistcoat_measure'], input[type='checkbox'][name='waistcoat_gr_measure'], input[type='checkbox'][name='shirt_measure'], input[type='checkbox'][name='shirt_gr_measure']", function(){
    if($(this).prop("checked") == true){
      cm_to_inch_for_custom($(this));
    }else{
      inch_to_cm_for_custom($(this));
    }
  });
  
  $(document).on("click", ".apply_btn", function(){
    var get_val = $(this).parents(".size-inpt-footer").find(".size-inptbx .size-input-ele:visible").val();
    $(this).parents(".size-input").find(".outer_box .size-input-ele:visible").val(get_val);
    $(this).parents(".size-input").find(".size-inpt-popup").removeClass("opened");
    $(this).parents(".sct-popup-block").find(".sct-inpt-mask").removeClass("showed");
  });
  
  /* Open size drawer when size not selected */
  $(document).on("click", ".add_to_cart_btn", function(e){
    e.preventDefault();
    if($(this).parents("form").length > 0){
      $(this).parents("form").find(".select-var-dropdown-btn").trigger("click");
    }
  });
  
  /* Reset Value */
  $(document).on("click", ".size-reset", function(){
    var parent_cls = $(this).parents(".sct-tabs-Grid");
    
    var currCustId = $(this).parents(".sct-size-popup").data("cust-id");
    
    parent_cls.find(".outer_box").find(".size-input-ele").each(function(){
      if(parent_cls.find("input[type='checkbox']").is(":checked") == true){
        var value = parseFloat($(this).attr("data-value"));
        //var new_val = (value / 2.54).toFixed(2);
        if(value > 0){
          $(this).val(value.toFixed(1));
          $(this).attr("data-calval", value);
        }
      }else{
        var value1 = parseFloat($(this).attr("data-value"));
        var new_val1 = (value1*2.54).toFixed(1);
        if(new_val1 > 0){
          $(this).val(new_val1);
        }
      } 
    });
  });
  
  /* Measurement Value Increment */
  $(document).on("click", ".size-iplus", function(){
    change_size($(this), "plus");
  });
  
  /* Measurement Value Decrement */
  $(document).on("click", ".size-iminus", function(){
    change_size($(this), "minus");
  });
  
  /* Remove opacity on input in size drawer */
  $(document).on("click", ".size-inptbx", function(){
   $(this).parents(".size-input").removeClass("opacity_cls");
  });
 
  $(document).on("click", ".notify_btn", function(e){
    e.preventDefault();
    var val;
    var type = $(this).parents(".sct-size-varients").attr("id");
    var jacket = [];
    var trousers = [];
    
    if(type == 'Jacket'){
      $(".product-form").find(".Jacket_select_box .single-option-selector option").each(function(){
        if($(this).data("class") == 'soldout'){
          val = $(this).val();
          return false;
        }
      });
      
      setTimeout(function(){
        if($(".bestpush-bis-notify-button").length > 0){
          $(".product-form")
          .find('.Jacket_select_box').find('.single-option-selector')
          .eq(0)
          .val(val)
          .trigger('change');
        }
      }, 300);
      
      $(".product-form").find(".Jacket_select_box .single-option-selector option").each(function(){
        if($(this).data("class") == 'soldout'){
          jacket.push($(this).val())
        }
      });
      
    }else if(type == 'Trousers'){
      $(".product-form").find(".Trousers_select_box .single-option-selector option").each(function(){
        if($(this).data("class") == 'soldout'){
          val = $(this).val();
          return false;
        }
      });
      
      setTimeout(function(){
        if($(".bestpush-bis-notify-button").length > 0){
          $(".product-form")
          .find('.Trousers_select_box .single-option-selector')
          .eq(0)
          .val(val)
          .trigger('change');
        }
      }, 300);
      
      $(".product-form").find(".Trousers_select_box .single-option-selector option").each(function(){
        if($(this).data("class") == 'soldout'){
          trousers.push($(this).val())
        }
      });
      
    }else{
      $(".product-form").find(".single-option-selector option").each(function(){
        if($(this).data("class") == 'soldout'){
          val = $(this).val();
          return false;
        }
      });
      
      setTimeout(function(){
        if($(".bestpush-bis-notify-button").length > 0){
          $(".product-form")
          .find('.single-option-selector')
          .eq(0)
          .val(val)
          .trigger('change');
        }
      }, 300);
      
    }
    
    /*$(".product-form").find(".single-option-selector option").each(function(){
      if($(this).data("class") == 'soldout'){
        val = $(this).val();
        return false;
      }
    });*/
    
    /*setTimeout(function(){
    $(".product-form")
        .find('.single-option-selector')
        .eq(0)
        .val(val)
        .trigger('change');
    }, 300);*/
    
    setTimeout(function(){
      $(".bestpush-bis-notify-button").trigger("click");
    }, 600);
    
    setTimeout(function(){
      $(".bestpush-bis-unselectable-variant-select option").each(function(index){
        if(jacket.length > 0){
          if(jacket.indexOf($(this).text()) == -1){
            $(this).remove();
          }
        }else if(trousers.length > 0){
          if(trousers.indexOf($(this).text()) == -1){
            $(this).remove();
          }
        }
      });
      jacket.length = 0;
      trousers.length = 0;
    }, 1000);
  });

  /* Change product price click on select size drawer select button */
  /*$(document).on("click", ".sct-size-btn", function(){
   var data_id = $(this).attr("data-id");
   var updated_price = $("#"+data_id).find(".sct-popup-footer .price").text();
   $("#shopify-section-product-template").find("#ProductPrice-product-template").text(updated_price);
  });

  if($(".sct-size-popup").length > 0){
    var id = $(".sct-size-popup").find(".sct-size-list").find(".sct-size-item").eq(0).find(".sct-size-btn").attr("data-id");
    var price = $(".sct-size-popup").find("#"+id).find(".sct-popup-footer .price").text();
    $("#shopify-section-product-template").find("#ProductPrice-product-template").text(price);
  }*/

  function price_set(object){
    var obj = $(object);
    var len = obj.parents(".sct-popup-block").find(".size-var-list").find(".active").length;
    
    if(len < 2){
      obj.parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney(obj.attr("data-price"), theme.moneyFormat));
    }else{
      var price_new_array = [];
      obj.parents(".sct-popup-block").find(".size-var-list").find(".active").each(function(){
        price_new_array.push(obj.attr("data-price"));
      });
      obj.parents(".sct-popup-block").find(".price").text(theme.Currency.formatMoney(eval(price_new_array.join('+')), theme.moneyFormat))
    }
  }
  
  /* Convert measure from cm to inch */
  function cm_to_inch(obj){
    obj.parents(".sct-tabs-Grid, .meausre-main").find(".size-unt-inpts").find(".size-input").find(".outer_box .size-input-ele, .size-inpt-footer .size-input-ele").each(function(){
      if($(this).hasClass("cls-dropdwn") == false){
        $(this).attr("step", $(this).parents(".sct-popup-body, .meausre-main").attr("data-inch-step"));
        var new_min = ($(this).attr("min")/2.54).toFixed(1);
        var new_max = ($(this).attr("max")/2.54).toFixed(1);
        $(this).attr("min", new_min);
        $(this).attr("max", new_max);
        var value = parseFloat($(this).val());
        var new_val = (value / 2.54).toFixed(1);
        $(this).attr("data-calval", (value / 2.54).toFixed(2));
        $(this).val(new_val.replace(",", "."));
      }else{
        if($(this).parents(".size-input").find(".size-inpt-footer .dropdown_inch").length > 0){
          $(this).parents(".size-input").find(".size-inpt-footer .dropdown_inch").hasClass("hide") ? $(this).parents(".size-input").find(".size-inpt-footer .dropdown_inch").removeClass("hide") : '';
          $(this).parents(".size-input").find(".size-inpt-footer .dropdown_cm").addClass("hide");
        }
        if($(this).parent(".outer_box").find(".dropdown_inch").length > 0){
          $(this).parent(".outer_box").find(".dropdown_inch").hasClass("hide") ? $(this).parent(".outer_box").find(".dropdown_inch").removeClass("hide") : '';
          $(this).parent(".outer_box").find(".dropdown_cm").addClass("hide");
        }
      }
    });
  }

  function cm_to_inch_for_custom(obj){
    //obj.parents(".sct-popup-body").find(".size-unt-inpts").find(".size-input").find(".outer_box .size-input-ele, .size-inpt-footer .size-input-ele").each(function(){
    if(obj.parents("#custom-jacket-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("inch");
    }else if(obj.parents("#custom-trouser-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("inch");
    }else if(obj.parents("#custom-waistcoat-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("inch");
    }else if(obj.parents("#custom-shirt-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("inch");
    }
    
    obj.parents(".ac-measure-grid").find(".size-unt-inpts").find(".size-input").find(".outer_box .size-input-ele").each(function(){
      if($(this).hasClass("cls-dropdwn") == false){
        $(this).attr("step", $(this).parents(".meausre-main").attr("data-inch-step"));
        var new_min = ($(this).attr("min")/2.54).toFixed(1);
        var new_max = ($(this).attr("max")/2.54).toFixed(1);
        $(this).attr("min", new_min);
        $(this).attr("max", new_max);
        var value = parseFloat($(this).val());
        var new_val = (value / 2.54).toFixed(1);
        $(this).attr("data-calval", (value / 2.54).toFixed(2));
        $(this).val(new_val.replace(",", "."));
      }
    });
  }
  
  /* Convert measure from inch to cm */
  function inch_to_cm(obj){
    $(obj).parents(".sct-tabs-Grid, .meausre-main").find(".size-unt-inpts").find(".size-input").find(".outer_box .size-input-ele, .size-inpt-footer .size-input-ele").each(function(){
      if($(this).hasClass("cls-dropdwn") == false){
        $(this).attr("step", $(this).parents(".sct-popup-body, .meausre-main").attr("data-cm-step"));
        var new_min = Math.round($(this).attr("min")*2.54);
        var new_max = Math.round($(this).attr("max")*2.54);
        var calval = parseFloat($(this).attr("data-calval"));
        $(this).attr("min", new_min);
        $(this).attr("max", new_max);
        var value = parseFloat($(this).val());
        var new_val = parseFloat(calval * 2.54).toFixed(1);
        $(this).val(new_val.replace(",", "."));
      }else{
        if($(this).parents(".size-input").find(".size-inpt-footer .dropdown_cm").length > 0){
          $(this).parents(".size-input").find(".size-inpt-footer .dropdown_cm").hasClass("hide") ? $(this).parents(".size-input").find(".size-inpt-footer .dropdown_cm").removeClass("hide") : '';
          $(this).parents(".size-input").find(".size-inpt-footer .dropdown_inch").addClass("hide");
        }
        if($(this).parent(".outer_box").find(".dropdown_cm").length > 0){
          $(this).parent(".outer_box").find(".dropdown_cm").hasClass("hide") ? $(this).parent(".outer_box").find(".dropdown_cm").removeClass("hide") : '';
          $(this).parent(".outer_box").find(".dropdown_inch").addClass("hide");
        }
      }
    });
  }

  function inch_to_cm_for_custom(obj){
    if(obj.parents("#custom-jacket-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("cm");
    }else if(obj.parents("#custom-trouser-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("cm");
    }if(obj.parents("#custom-waistcoat-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("cm");
    }if(obj.parents("#custom-shirt-measurement-modal").length > 0){
      obj.parents(".ac-measure-grid").find(".measure_unit").val("cm");
    }
    
    $(obj).parents(".ac-measure-grid").find(".size-unt-inpts").find(".size-input").find(".outer_box .size-input-ele").each(function(){
      if($(this).hasClass("cls-dropdwn") == false){
        $(this).attr("step", $(this).parents(".meausre-main").attr("data-cm-step"));
        var new_min = Math.round($(this).attr("min")*2.54);
        var new_max = Math.round($(this).attr("max")*2.54);
        var calval = parseFloat($(this).attr("data-calval"));
        $(this).attr("min", new_min);
        $(this).attr("max", new_max);
        var value = parseFloat($(this).val());
        var new_val = parseFloat(calval * 2.54).toFixed(1);
        $(this).val(new_val.replace(",", "."));
      }
    });
  }
  
  /* Size increment and decrement */
  function change_size(obj, task){
    obj.parents(".size-input").removeClass("opacity_cls");
    var val = obj.parents(".size-inptbx").find(".size-input-ele").val();
    var max_val = parseFloat(obj.parents(".size-inptbx").find(".size-input-ele").attr("max"));
    var min_val = parseFloat(obj.parents(".size-inptbx").find(".size-input-ele").attr("min"));
    var new_val;
    var step;

    if(val != ''){
      step = obj.parents(".size-inptbx").find(".size-input-ele").attr("step");
      if(obj.parents(".sct-tabs-Grid, .meausre-main").find("input[type='checkbox']").is(":checked") == true){
        step = obj.parents(".sct-popup-body, .meausre-main").attr("data-inch-step");
      }else{
        step = obj.parents(".sct-popup-body, .meausre-main").attr("data-cm-step");
      } 
      
      if(task == 'plus'){
        if(obj.parents(".custom_made_popup").length > 0){
          // For custom made
          if(obj.parents(".ac-measure-grid").find("input[type='checkbox']").is(":checked") == true){
            new_val = (parseFloat(val)+parseFloat(step)).toFixed(2);
            obj.parent(".outer_box").find(".size-input-ele").attr("data-calval", new_val);
          }else{
            new_val = parseFloat(val)+parseFloat(step);
          }
        }else{
          // For Suit
          if(obj.parents(".sct-popup-body, .meausre-main").find("input[type='checkbox']").is(":checked") == true){
            new_val = (parseFloat(val)+parseFloat(step)).toFixed(2);
            obj.parent(".outer_box").find(".input_bx_cls").attr("data-calval", new_val);
          }else{
            new_val = parseFloat(val)+parseFloat(step);
          }
        }
      }else{
        if(obj.parents(".custom_made_popup").length > 0){
          // For custom made
          if(obj.parents(".ac-measure-grid").find("input[type='checkbox']").is(":checked") == true){
            new_val = (parseFloat(val)-parseFloat(step)).toFixed(2);
          }else{
            new_val = parseFloat(val)-parseFloat(step);
          }
        }else{
          // For Suit
          if(obj.parents(".sct-popup-body, .meausre-main").find("input[type='checkbox']").is(":checked") == true){
            new_val = (parseFloat(val)-parseFloat(step)).toFixed(2);
          }else{
            new_val = parseFloat(val)-parseFloat(step);
          }
        }
      }
      
      obj.parents(".size-inptbx").find(".size-input-ele").val(new_val);
      
      const el = obj.parents(".size-inptbx").find(".size-input-ele");

      if(el[0]['max'] && el[0]['min'] ){
        let value = parseFloat(el[0].value)
        el[0].value = value // for 000 like input cleanup to 0
        let max = parseFloat(el[0].max)
        let min = parseFloat(el[0].min)
        if ( value > max ) el[0].value = el[0].max
        if ( value < min ) el[0].value = el[0].min
      }
    }

  }
  
  /* Function for show cart drawer */
  function showDrawer(i) {
    $("body").addClass("line-loading showOverly");
    $(i).fadeIn(500);
    drawerTimeout = setTimeout(function () {
      $("body").removeClass("line-loading showOverly"), $(i).fadeOut(200);
    }, 6000);
  }
  
  /* Function for product add to cart */
  function add_to_cart_product(id,prop, obj){
    //$(".loadingBox").show();
    obj.parents(".ld-hydrated-box").addClass("line-loading");
    CartJS.addItem(
      id,
      1,
      prop,
      {
        success: function (data, textStatus, jqXHR) {
          if($(".mini-products-list").hasClass("empty_box")){
            $(".mini-products-list").removeClass("empty_box");
          }
          if($(".cart__title").hasClass("empty_content")){
            $(".cart__title").removeClass("empty_content");
          }
          $("#successDrawer").find(".modal-prod-img").attr("src", "");
          //console.log(data);
           getCartDrawer();
          //var newCount = $(data).find(".site-header__cart-count").text();
          //$(".site-header__cart-count").text(newCount);
          if(data.image != null){
            var pimg = data.image,
                pimg_path = pimg.replace(/(\.[^\.]*$|$)/, "_small" + "$&");
            $("#successDrawer").find(".modal-prod-img").attr("src", pimg_path);
          }
          $("#successDrawer").find(".modal-prod-name").text(data.product_title);
          $("body").removeClass("line-loading showOverly");
          setTimeout(function () {
            $("body").addClass("cart-open");
            $("#header-cart").addClass("activeCart");
            $("#header-cart").addClass("activeCartToggle");
            //$(".loadingBox").hide();
            obj.parents(".ld-hydrated-box.line-loading").removeClass("line-loading");
            
            if($(".mini-products-list").find(".priceRow").find("span[rv-text='item.variant_title']").length > 0){
              $(".mini-products-list").find(".priceRow").find("span[rv-text='item.variant_title']").each(function(){
                if($(this).text() == 'Custom Made: Your specific measurements'){
                  $(this).text('');
                }
              });
            }
          }, 1000);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          //$(".loadingBox").hide();
          obj.parents(".ld-hydrated-box.line-loading").removeClass("line-loading");
          var errormsg = JSON.parse(jqXHR.responseText).description;
          $("body").removeClass("line-loading");
          $(".error-message").text(errormsg), showDrawer("#errorDrawer");
        },
      }
    );
  }

  function cartHeight() {
    var headerHeight = $('.header-wrap').innerHeight();
    var viewportHeight = $(window).height();
    var remainHeight = $(window).height() - $('.header-wrap').innerHeight();
    var innerHeight = remainHeight - $('.subtotalItems').innerHeight();
    
    //$('#header-cart').css('height', remainHeight);
    $('.productItems').css('height', innerHeight);
  }

  cartHeight();
  $(window).resize(function(){
    cartHeight();
  });
  $(window).on('scroll', function(){
    cartHeight();
  });
});

if($(".sct-type-tabs .sct-type-tab").length > 0){
  var id = $(".sct-type-tabs .sct-type-tab.active").data("id");
  $(".script_tg [type='application/json']").each(function(){
    if($(this).hasClass(id+"_json")){
      $(this).addClass("active_pro");
    }
  });
  
  $("."+id+"_select_box").find(".single-option-selector").addClass("active_select_box")
}

$(document).on("click", ".advanced-options", function(){
  $(this).toggleClass("active");
  $(this).next(".size-unt-inpts").slideToggle();
});

/* collection page filter */
$(document).on('click', '.Filter-btn', function(){
  $('html').addClass('filter-pop-opnd');
});

$(document).on('click', '.Filter-popup-mask', function(){
    $('html').removeClass('filter-pop-opnd');
});

$(document).on('click', '.Filter-popup-close', function(){
  $('.Filter-popup-mask').trigger('click');
});

/* Get sizes which have different data */
$(document).on("click", ".select-size-drawer", function(){
  var _this_obj = $(this);
  var data_id = $(this).parents(".sct-popup-block").find(".sct-popup-body .sct-type-tab.active").data("id");
  $(this).next('.size-inpt-popup').find(".size-inpt-body").addClass('hide');
  $(this).parents('.sct-popup-block').find('.sct-inpt-mask').addClass('showed');
  $(this).next('.size-inpt-popup').addClass('opened');
  $(this).next('.size-inpt-popup').find("#"+data_id+"-size-data").removeClass('hide');
  var data_url = $(this).next('.size-inpt-popup').find("#"+data_id+"-size-data").data("url");
  
  if(data_url){
    fetch(data_url)
    .then(resp_data => resp_data.text())
    .then(data => {
      const txt_data = csvToArray(data);
      for(var i=0; i<txt_data.length; i++){
        if(_this_obj.next('.size-inpt-popup').find("#"+data_id+"-size-data").find(".size-var-item[data-val='"+txt_data[i]['size'].trim()+"']").length < 0){
          _this_obj.next('.size-inpt-popup').find("#"+data_id+"-size-data").find(".size-var-item[data-val='"+txt_data[i]['size'].trim()+"']").css("display", "none");
        }
      }
    });
  }
});

/* Get different size wise data from csv file */
$(document).on("click", ".select-size-button", function(){
  var url = $(this).parents(".size-inpt-popup").find(".size-inpt-body").not(".hide").data("url");
  var size = $(this).parents(".size-inpt-popup").find(".size-inpt-body").not(".hide").find(".size-var-list .active").data("val");
  var this_obj = $(this);
  var measure_tp = this_obj.parents(".sct-popup-block").find(".sct-tabs-Grid.selected").find("input[type='checkbox']").prop("checked");
  
  if(url){
    fetch(url)
    .then(resp_data => resp_data.text())
    .then(data => {
      const data1 = csvToArray(data);
      for(var i=0; i<data1.length; i++){
        
        if(data1[i]['size'].trim() == size.trim()){
          $.each(data1[i], function(key, value){
            var l_case = key.toLowerCase();
            var key = l_case.replaceAll(" ", "_");
            if(value != ''){
              this_obj.parents(".sct-popup-block").find(".sct-tabs-Grid.selected").find(".size-input").each(function(){
                if(isNaN(value)){
                  $(this).find("select."+key+" option[value='"+value+"']").prop("selected", true);
                }else{
                  if(measure_tp == true){
                    /* inches */
                    $(this).find("."+key).val((value/2.54).toFixed(1));
                    $(this).find("."+key).attr("data-value", (value/2.54).toFixed(2));
                    $(this).find("."+key).attr("data-calval", (value / 2.54).toFixed(2));
                  }else{
                    /* cm */
                    $(this).find("."+key).val(value);
                    $(this).find("."+key).attr("data-value", (value/2.54).toFixed(2));
                  }
                }
                $(this).removeClass("opacity_cls");
              });
            }else{
              
            }
          });
        }
      }
      this_obj.parents(".sct-popup-head").find(".custom-size-drawer .select-size-drawer span:first").text(size);
      this_obj.parents(".sct-popup-block").find(".sct-inpt-mask").trigger("click"); /*removeClass("showed");*/
      this_obj.parents(".garment_measurements_sec").find(".sct-popup-footer").find(".sct-add-cart .garment_measure_cart_btn").removeClass("disabled");
      this_obj.parents(".garment_measurements_sec").find(".tab_cls").find(".sct-type-tabs .sct-type-tab").removeClass("disabled");
      this_obj.parents(".garment_measurements_sec").find(".sct-popup-footer").find(".sct-toggle-ele").find(".btm_tab .sct-toggle-item").removeClass("disabled");
    });
  }
});

/* login using ajax */
$(".sct-size-popup").find('.cust-login').click(function(event) {
  event.preventDefault();
  var form = $(this).parents("form");
  
  var email_pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  var email = form.find(".email").val();
  var password = form.find(".password").val();
  
  if(email == ''){
    form.find(".error-msg").show().find("span").text("Enter your email address");
    form.find(".email").focus();
    return false;
  }else if(!email_pattern.test(email)){
    form.find(".error-msg").show().find("span").text("Enter your valid email address");
    form.find(".email").focus();
    return false;
  }else if(password == ''){
    form.find(".error-msg").show().find("span").text("Enter your password");
    form.find(".password").focus();
    return false;
  }else{
    form.find(".error-msg").hide().find("span").text('');
    $(this).parent(".sign-in-btn").addClass("active-loader");
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };

    $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      success:function(data){
        if($(data).find(".account__pages").length > 0){
          //var cust_id = $(data).find(".account__pages").find(".cust-id").val();
          $(".sct-size-popup").load(location.href + " .sct-size-popup");
        }else if($(data).find(".login-page").length > 0){
          form.find(".error-msg").show().find("span").text($(data).find(".login-page").find(".errors ul li").text());
        }
        form.find(".sign-in-btn").removeClass("active-loader");
      }
    });
  }

});


/*setTimeout(function(){
  $(".mini-products-list").find("li[rv-show='cart.item_count | gt 0']").find(".remove").each(function(){
    $(this).on("click", function(){
      var obj = $(this);
      setTimeout(function(obj){
        $(".mini-products-list").find(".priceRow").find("span[rv-text='item.variant_title']").each(function(){
          if($(this).text() == 'Custom Made: Your specific measurements'){
            $(this).text('');
          }
        });
      }, 1000);
    });
  });
}, 1000);*/

function csvToArray(str, delimiter = ",") {
  const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\n");

  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });
  return arr;
}

/* use '284749692970' this user id for testing */
function get_order_data(user_id, type, callback){
  $.ajax({
    type:'POST',
    url:'https://mesurement.grandlemar.com/shopify/api/fetch_measurement/post',
    crossDomain: true,
    data:{ user_id:user_id, measurement_type:type },
    dataType:'json',
    success:function(succ_data){
      callback(succ_data);
    }
  });
}

function checkEmptyVal(obj, id, callback){
  if(typeof id !== 'undefined' || id != ''){
    obj.parents(".body_measurement_sec").find("#"+id).find(".size-unt-inpts .outer_box").find(".input_bx_cls").each(function(){
      var curVal = $(this).val();
      if(curVal == '' || curVal <= 0){
        $(this).parent(".size-inptbx").addClass("err-cls");
        $(this).parents(".size-input").removeClass("opacity_cls");
        $(this).focus();
        callback(false);
        return false;
      }else{
        $(this).parent(".size-inptbx").removeClass("err-cls");
      }
    });
    //console.log(id, obj.parents(".garment_measurements_sec").find(".sct-popup-head").find(".custom-size-drawer").find("#"+id+"-size-data").find(".active").length);
    //console.log("id", id);
    /*if(obj.parents(".garment_measurements_sec").find(".sct-popup-head").find(".custom-size-drawer").find("#"+id+"-size-data").find(".active").length == 0){
      callback(false);
      return false;
    }else{
      callback(true);
      return true;
    }*/
  }
}

function getCartDrawer(){
  $.ajax({
    type:"GET",
    url:"/collections",
    dataType:'html',
    success:function(data){
      var newHTML = $(data).find("#header-cart").html();
      var newCount = $(data).find(".site-header__cart-count").text();
      $(".site-header__cart-count").text(newCount);
      $("#header-cart").html(newHTML);
      $("#header-cart").find(".subtotalItems .buttonSet").find(".btn-cart-link").attr('href', $(".site-header__cart-count").parents(".site-header__cart").attr("href"));
    }
  });
}


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
    };
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);



loadMoreBtnSearch = function () {
  $(".infinitpagin a.loadMore_search").click(function (e) {
    e.preventDefault();
    var moreURLSearch = $(this).attr("href");
    loadMoreSearch(moreURLSearch);
  });
};

loadMoreSearch = function (moreURLSearch) {
  if (moreURLSearch.length) {
    $.ajax({
      type: "GET",
      dataType: "html",
      url: moreURLSearch,
      beforeSend: function () {
        if ($(".infinitpaginOuter").attr("data-type") == "button") {
          $("body").addClass("line-loading hideOverly");
        }
      },
      complete: function (data) {
        if($(".search_page_box").length){
          $(".search_page_box").append($(".search_page_box", data.responseText).html());
        }

        if($(".search_paginatation").length > 0 && $(".search_paginatation", data.responseText).length > 0){
          $(".search_paginatation").html($(".search_paginatation", data.responseText).html());
        }else{
          $(".search_paginatation").hide();
        }

        if ($(".spr-badge").length > 0) {
          $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
        }

        if ($(".infinitpagin a.loadMore_search").length) {
          loadMoreBtnSearch();
        }
        $("body").removeClass("line-loading hideOverly");
      },
    });
  }
};

$(document).ready(function () {
  loadMoreBtnSearch();
  $(document).on("click", ".search_icon_btn", function(){
    $(this).parents("form").find("button.searchSubmit").trigger("click");
  });
  $(document).on("click", ".search-ts", function(){
    $(this).parents("form").find("button.searchSubmit").trigger("click");
  });

  $(document).on("click", ".account__pages .popup-modal", function(){
    if(!$('html').hasClass("popup-model-open")){
     $('html').addClass("popup-model-open"); 
    }
  });

  $(document).on("click", ".account__pages .popup-modal-dismiss", function(){
    if($('html').hasClass("popup-model-open")){
     $('html').removeClass("popup-model-open"); 
    }
    if($('html').hasClass("delete-popup-open")){
     $('html').removeClass("delete-popup-open"); 
    }
  });

  /*$(document).on("click", "#SearchDrawerInner0 .close-country-drawer", function() {
    $(this).parents("#SearchDrawerInner0").find(".close-ts-drawer-nowd").trigger("click");
  });*/

  $(document).on("click", ".cart_continue", function() {
    $("body").trigger("click");
  });

  $(document).on("click", '#openSearch', function(){
    $('body').addClass("mobilesearchActive");
    $("html").addClass("preventScroll");
  });

  // Function to prevent body scroll but allow specific element scroll
/*function preventBodyScroll(e) {
  // If scrolling within .mobile__search__sec, allow it
  let mobileSearchSection = document.querySelector(".mobile__search__sec");
  
  if (!mobileSearchSection.contains(e.target)) {
    e.preventDefault(); // Prevent body scroll
  }
}*/

// Enable body scroll lock on input focus
/*document.querySelector(".mobile__search__sec #search_h_input-input").addEventListener('focusin', function(e) {
  if (e.target.tagName === 'INPUT') {
    // Disable body scroll
    document.body.style.overflow = 'hidden';

    // Add event listener to prevent body scrolling
    document.body.addEventListener('touchmove', preventBodyScroll, { passive: false });
    
    // Allow scroll inside the search section
    let mobileSearchSection = document.querySelector(".mobile__search__sec");
    mobileSearchSection.style.overflow = 'auto';
    mobileSearchSection.style.touchAction = 'auto'; // Ensure touch scrolling works
  }
});

// Re-enable body scroll on input blur (focusout)
document.querySelector(".mobile__search__sec #search_h_input-input").addEventListener('focusout', function(e) {
  // Enable body scroll again
  document.body.style.overflow = '';

  // Remove the scroll prevention listener
  document.body.removeEventListener('touchmove', preventBodyScroll);
});*/

  
  $(document).on("click", '.mobile__search__sec #search-closed', function(){
    $('body').hasClass("mobilesearchActive") ? $('body').removeClass("mobilesearchActive") : '';
    $('html').hasClass("preventScroll") ? $('html').removeClass("preventScroll") : '';
  })

  /* Collection page */
  $(document).on("click", ".shop_controls .view_wrappers .select-btn", function(){
    $(this).parent(".view_wrappers").hasClass("active") == true ? $(this).parent(".view_wrappers").removeClass("active") : ($(this).parents(".shop_controls").find(".view_wrappers.active").removeClass("active"), $(this).parent(".view_wrappers").addClass("active"));
  });

  $('body').click(function(event) {
    if ($(event.target).closest('.select-btn').length === 0) {
      $(".shop_controls").find(".active").removeClass("active");
    }
  });

  $(document).on("change", ".fix_addtocart .single-option-selector", function(){
    const currVal = $(this).val();
    $("#product-page--form--custom").find("select").val(currVal).trigger("change");
  });

  $(window).scroll(function() {
    if($(window).width() < 992){
      if ($(document).find(".fix_addtocart").length > 0) {
        var docViewTop = $(window).scrollTop();
        var eleTop = $("#product-page--form--custom .btn-group").offset().top + $("#product-page--form--custom .btn-group").height();
        
        if($(".stl__embeded").length > 0){
          var shopTheLookBtn = $(".stl__embeded").offset().top - $(window).height();
        }else{
          var shopTheLookBtn = $("#shopify-section-footer").offset().top;
        }
        
        if(docViewTop > eleTop && docViewTop < shopTheLookBtn){
          $(".fix_addtocart").not(".is_hide").parents("body").addClass("isActivestickyCart");
          toggleBtnGroup();
        }else if(shopTheLookBtn < eleTop){
          $(".fix_addtocart").not(".is_hide").parents("body").addClass("isActivestickyCart");
          toggleBtnGroup();
        }else{
          $("body").removeClass("isActivestickyCart");
        }
      }
    }
  });

  function toggleBtnGroup() {
    $('.fix_addtocart .btn-group').each(function () {
      var $group = $(this);
      var $options = $group.find('.productOptions');
      if($options.length > 0) {
        var isEmpty = $options.length === 0 || $options.text().trim() === '';
        $group.toggleClass('hide', isEmpty);
      }
    });
  }

  $(document).on("click", ".fix_addtocart .close_sticky_bar", function(){
    $("body").removeClass("isActivestickyCart");
    $(this).parents(".fix_addtocart").addClass("is_hide");
  });

  $(document).on("click", ".product-details-tabs .pro-details-tabs-items-wrapper li", function(){
    let currId = $(this).find("a").attr("data-href");
    $(this).addClass("pro-tab-active").siblings("li").removeClass("pro-tab-active");
    $(this).parents(".product-details-tabs").find(currId).removeClass("hidden").siblings(".pro-tabs-content").addClass("hidden");
  });

  // Clear cart data (If the custom made product is available in the cart) at the logout time
  $(document).on("click", "a[href='/account/logout']", function(event) {
    event.preventDefault();
    var isCustomMade = false;
    jQuery.getJSON('/cart.js', function(cart) {
      if(cart.items.length > 0){
        for(let i=0; i<cart.items.length; i++){
          if(cart.items[i]['properties']){
            if(cart.items[i]['properties']['_measurement_type']){
              isCustomMade = true;
            }
          }
        }
      }
      
      if(isCustomMade){
        fetch('/cart/clear.js', {
          method: 'POST',
        })
        .then(response => {
          if (response.ok) {
             window.location.href = '/account/logout';// Redirect after clearing cart
          } else {
            console.error('Error clearing cart:', response.statusText);
          }
        })
        .catch(error => {
          console.error('Error clearing cart:', error);
        });
      }else{
        window.location.href = '/account/logout';
      }
    });
  });

});

/* Custom filter option open close  */
$(document).on("click", ".flt-block-title", function() {
  var $parentBlock = $(this).closest(".flt-option-block");
  var $currentContent = $(this).next(".flt-block-content");
  $currentContent.slideToggle();
  $parentBlock.toggleClass("active");
});

/* View : Smaller/Larger */
$(document).off("change", ".shop_controls #btn-grid").on("change", ".shop_controls #btn-grid", function(){
  let isOptionChecked = $(this).is(":checked");
  var layAttr = isOptionChecked ? 'grid-4' : 'grid-2';
  let newLayoutMode = layAttr == 'grid-4' ? 'smaller-matrix-grid' : 'larger-matrix-grid';
  $(this).parent().find('label').text(layAttr);
  layAttr == 'grid-4' ? $(this).parent().find('label').text('View: Smaller') : $(this).parent().find('label').text('View: Larger');
  console.log('layAttr', layAttr);
  console.log('newLayoutMode', newLayoutMode);

  fetch("/cart/update.js", {
    body: JSON.stringify({
      attributes: {
        'collection_view': layAttr
      }
    }),
    credential: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  if($(this).parents("#Collection").find(".collection_matrix").hasClass(newLayoutMode)){
    return;
  }

  $(this).parents("#Collection").find(".smaller-matrix-grid").removeClass("smaller-matrix-grid");
  $(this).parents("#Collection").find(".larger-matrix-grid").removeClass("larger-matrix-grid");
  setTimeout(() => { $(this).parents("#Collection").find(".collection_matrix").addClass(newLayoutMode); }, 300);
  $(this).parents(".shop_controls").find(".view_wrappers.active").removeClass("active");
});

/* View : Product/Model */
$(document).on("change", ".shop_controls #btn-view", function(){
  let isOptionChecked = $(this).is(":checked");
  var newDisplayMode = isOptionChecked ? 'product' : 'model';
  $(this).parent().find('label').text("View: "+ newDisplayMode);

  fetch("/cart/update.js", {
    body: JSON.stringify({
      attributes: {
        'collection_display': newDisplayMode
      }
    }),
    credential: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  var cnt = 0;
  /*$(this).closest("#Collection").find(".productList .coll_matrix_item").each(function(){
    var modelImage = $(this).find(".pro-list-img").find(".pro-inner-effect-model"),
        proImage = $(this).find(".pro-list-img").find(".pro-inner-effect-product");
    if(newDisplayMode == 'model'){
      proImage.hasClass("active") ? (modelImage.addClass("active"), proImage.removeClass("active")) : '';
    }else if(newDisplayMode == 'product'){
      if(modelImage.length > 0){
        modelImage.hasClass("active") ? (proImage.addClass("active"), modelImage.removeClass("active")) : '';    
      }else{
      }
    }
  });*/

  const productList = this.closest("#Collection").querySelector(".productList .collection_matrix_list");
  if (productList) {
    window.resetProductSliders(productList, newDisplayMode);
  }
});

/* Clear cart attributes on checkout button click */
$(document).on("click", "input[name='checkout'], a[href='/checkout']", function(event){
  fetch("/cart/update.js", {
    body: JSON.stringify({
      attributes: {
        'collection_view': '',
        'collection_display': ''
      }
    }),
    credential: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(function (response) {
    return false;
    if(response.ok){
      return true;
    }
  })
});

/*  open size guide on click from product description tab 'SIZE GUIDE & FIT'  */
function openSizeGuide() {
  if($(".product_descr").find(".smartsize-button-text").length > 0){
    $(".product_descr").find(".smartsize-button-text").trigger("click");
  }else if($(".product_descr .size_guide_box").length > 0){
    $(".product_descr .size_guide_box").find(".popup-modal").trigger("click");
  }
}

